import React from 'react';
import PropTypes from 'prop-types';

import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const CardHeader = props => {

    const { title, urlAssets } = props;

    return (
        <section className="mt-4 text-center">
            <LazyLoadImage
                alt={title}
                className="img-fluid"
                effect="blur"
                src={`${urlAssets}/img/bienvenido-2022-card-header.png`}
            /> 
        </section>
    )
}

export default CardHeader;

CardHeader.propTypes = {
    title: PropTypes.string.isRequired,
    urlAssets: PropTypes.string.isRequired,
    urlBrand: PropTypes.string.isRequired
}